// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyARaeSxaZfiFP-xVWBwgBqN9141P32kjN4",
  authDomain: "matkhan-619b0.firebaseapp.com",
  projectId: "matkhan-619b0",
  storageBucket: "matkhan-619b0.firebasestorage.app",
  messagingSenderId: "757610315444",
  appId: "1:757610315444:web:cef6c5640152d90e02a1e1",
  measurementId: "G-MJEZSH112Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app); // Optional

export { app, auth, db, analytics };
